import { Component, Input } from '@angular/core';
import { Audesp4ComprasServicos, Audesp4ComprasServicosTI } from 'eddydata-lib';
import { BaseLicitacaoAudesp } from '../../util/base-licitacao-audesp';
//import * as toastr from 'toastr';

declare var $: any;

@Component({
  selector: 'lib-licitacao-audesp-amostra',
  templateUrl: './licitacao-audesp-amostra.component.html'
})
export class LicitacaoAudespAmostraComponent extends BaseLicitacaoAudesp {

  @Input() public objeto: Audesp4ComprasServicos | Audesp4ComprasServicosTI;

  constructor(
  ) {
    super()
  }
}
